module.exports = __webpack_public_path__ + "img/21.46940f13.png";